// 测试/预发布环境 (beta)

const config = {
  backend: "https://beta.jab-pgxcloud.com/v1",
  wsUri: "wss://beta.jab-pgxcloud.com/v1",
  oss: "pgxcloud-upload-dev.oss-cn-beijing.aliyuncs.com",
  urlPrefix: "/jab"
}

export default {
  backend: config.backend,
  wsUri: config.wsUri,
  oss: config.oss,
  urlPrefix: "/jab"
}

// // 生产环境 (www)
// const config = {
//   backend: "https://www.jab-pgxcloud.com/v1",
//   wsUri: "wss://www.jab-pgxcloud.com/v1",
//   oss: "pgxcloud-upload-dev.oss-cn-beijing.aliyuncs.com",
//   urlPrefix: "/jab"
// }

// export default {
//   backend: config.backend,
//   wsUri: config.wsUri,
//   oss: config.oss,
//   urlPrefix: "/jab"
// }




// WEBPACK FOOTER //
// ./src/app/config.js